import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom'
import logo from '../../Assets/images/logo.png'
import playstoreIcon from '../../Assets/images/playstoreIcon.png'
import appstoreIcon from '../../Assets/images/appstoreIcon.png'
import { getInstituteAPI } from '../../Services/InstituteMasterAPIURL'
import { postCancelMembershipAPIURL } from '../../Services/CancelMebershipAPIURL'
import { toast, ToastContainer } from 'react-toastify'

const CancelMembershipPage = ({ setShowCancelPage }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const [instData, setInstData] = useState(location.state?.instData || [])

  const [college, setCollege] = useState('')
  const [userId, setUserId] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (instData.length === 0) {
      axios.get(getInstituteAPI).then((res) => {
        if (res.data !== 'ERROR') {
          setInstData(res.data)
        }
      })
    }
  }, [])

  const deleteAccount = async () => {
    if (college === '') {
      toast.warning('Please Select College')
      return
    }

    if (userId.trim() === '') {
      toast.warning('Please Enter User Id')
      return
    }

    if (password.trim() === '') {
      toast.warning('Please Enter Password')
      return
    }

    const obj = {
      mail_id: userId,
      password: password,
    }

    try {
      const res = await axios.post(postCancelMembershipAPIURL, obj)

      if (res.data.status === 'success') {
        toast.success(res.data.message)

        setCollege('')
        setUserId('')
        setPassword('')

        setTimeout(() => {
          setShowCancelPage(false)
        }, 1500)
      } else {
        toast.error(res.data.message || 'Unable to delete account.')
      }
    } catch (err) {
      console.error(err)

      if (err.response?.data?.message) {
        toast.error(err.response.data.message)
      } else {
        toast.error('Something went wrong. Please try again.')
      }
    }
  }

  return (
    <>
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 mt-5">
            <div
              style={{
                background: '#fff',
                borderRadius: '10px',
                padding: '35px',
                boxShadow: '0 0 20px rgba(0,0,0,.25)',
                marginTop: '20px',
              }}
            >
              <h1
                className="text-center mt-3"
                style={{
                  fontWeight: '700',
                  color: '#000',
                  textShadow: '2px 2px 5px #999',
                }}
              >
                Cancel Your Membership
              </h1>

              <h6
                className="text-center"
                style={{
                  color: 'red',
                  marginTop: '25px',
                  marginBottom: '30px',
                  lineHeight: '28px',
                }}
              >
                This Process Deletes Your Account Permanently on LES
                Digital-Library.in.
                <br />
                After Deleting, Your Personal Data Will Be Removed From Our Site
              </h6>

              <div className="row mt-3 align-items-center">
                <div className="col-4 text-end">
                  <label style={{ fontWeight: '600' }}>Select College</label>
                </div>

                <div className="col-8">
                  <select
                    className="form-control"
                    value={college}
                    onChange={(e) => setCollege(e.target.value)}
                  >
                    <option value="">Select College</option>

                    {instData.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.institute_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="row mt-3 align-items-center">
                <div className="col-4 text-end">
                  <label style={{ fontWeight: '600' }}>User Id</label>
                </div>

                <div className="col-8">
                  <input
                    className="form-control"
                    placeholder="enter email"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                  />
                </div>
              </div>

              <div className="row mt-3 align-items-center">
                <div className="col-4 text-end">
                  <label style={{ fontWeight: '600' }}>Password</label>
                </div>

                <div className="col-8">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>

              <div className="text-center mt-3">
                <button
                  className="btn btn-secondary me-3"
                  style={{ width: 170 }}
                  onClick={() => setShowCancelPage(false)}
                >
                  Cancel
                </button>

                {/* <button
                  className="btn btn-secondary me-3"
                  style={{ width: 170 }}
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button> */}

                <button
                  className="btn btn-danger"
                  style={{ width: 180 }}
                  onClick={deleteAccount}
                >
                  Delete Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="footer">
        <div className="col-6 fc1">
          © LES Digital Library 2022 | Managed by:{' '}
          <a href="https://technoaarv.com/" target="_blank" rel="noreferrer">
            TechnoAarv Solution
          </a>
        </div>

        <div className="col-6 fc2">
          <a
            href="https://play.google.com/store/apps/details?id=com.digitallibrarysystem&hl=en"
            target="_blank"
            rel="noreferrer"
          >
            <img src={playstoreIcon} alt="" />
          </a>
        </div>
      </div> */}

      <div className="footer">
        <div className="fc1">
          © LES Digital Library 2022 | Managed by:{' '}
          <a href="https://technoaarv.com/" target="_blank">
            TechnoAarv Solution
          </a>
        </div>

        <div className="fc3">
          <a
            // href="https://play.google.com/store/apps/details?id=com.digitallibrarysystem&hl=en"
            href='https://apps.apple.com/in/app/les-digital-library/id6792469948'
            target="_blank"
          >
            <img src={appstoreIcon} alt="App store Icon" />
          </a>
        </div>

        <div className="fc2">
          <a
            // href="https://play.google.com/store/apps/details?id=com.digitallibrarysystem&hl=en"
            href='https://play.google.com/store/apps/details?id=com.les.digitallibrary&pcampaignid=web_share'
            target="_blank"
          >
            <img src={playstoreIcon} alt="Playstore Icon" />
          </a>
        </div>

        
      </div>

      <ToastContainer theme="warn" position="top-right" />
    </>
  )
}

export default CancelMembershipPage
